import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/avatar_ef_3.jpeg'


const _withScopeId = n => (_pushScopeId("data-v-ea280d86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main block-section" }
const _hoisted_2 = { class: "shadow rounded-xl overflow-hidden" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-32 bg-cover header-top" }, null, -1))
const _hoisted_4 = { class: "pt-14 p-7 bg-white relative flex flex-col items-stretch" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Avatar",
    class: "user-photo"
  })
], -1))
const _hoisted_6 = { class: "text-lg font-semibold mb-1.5" }
const _hoisted_7 = { class: "text-sm text-gray-400 mb-7" }
const _hoisted_8 = { class: "text-mm text-gray-400 mb-7 font-bold" }
const _hoisted_9 = { class: "w-full text-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 self-center mb-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.8",
    d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
  })
], -1))
const _hoisted_11 = { class: "download-links flex group h-12 justify-center" }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["alt", "title"]
const _hoisted_14 = ["href"]
const _hoisted_15 = ["alt", "title"]
const _hoisted_16 = ["href"]
const _hoisted_17 = ["alt", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_locale_selector = _resolveComponent("the-locale-selector")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.data.name[_ctx.$i18n.locale]), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.data.bd[_ctx.$i18n.locale]), 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.data.position[_ctx.$i18n.locale]), 1),
        _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t('CV.downloadBtnText')), 1),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("a", {
            class: "cvDocLink word",
            target: "_blank",
            href: _ctx.data.download.word.url[_ctx.$i18n.locale]
          }, [
            _createElementVNode("img", {
              class: "w-16",
              alt: _ctx.data.download.word.title[_ctx.$i18n.locale],
              title: _ctx.data.download.word.title[_ctx.$i18n.locale],
              src: "https://cdn-icons-png.flaticon.com/128/888/888883.png"
            }, null, 8, _hoisted_13)
          ], 8, _hoisted_12),
          _createElementVNode("a", {
            class: "cvDocLink gdoc",
            target: "_blank",
            href: _ctx.data.download.google.url[_ctx.$i18n.locale]
          }, [
            _createElementVNode("img", {
              class: "w-16",
              alt: _ctx.data.download.google.title[_ctx.$i18n.locale],
              title: _ctx.data.download.google.title[_ctx.$i18n.locale],
              src: "https://cdn-icons-png.flaticon.com/128/281/281760.png"
            }, null, 8, _hoisted_15)
          ], 8, _hoisted_14),
          _createElementVNode("a", {
            class: "cvDocLink pdf",
            target: "_blank",
            href: `/cv/AndrewButov_CV_2022_${_ctx.$i18n.locale}.pdf`
          }, [
            _createElementVNode("img", {
              class: "w-16",
              alt: _ctx.data.download.google.title[_ctx.$i18n.locale],
              title: _ctx.data.download.google.title[_ctx.$i18n.locale],
              src: "https://cdn-icons-png.flaticon.com/128/4726/4726010.png"
            }, null, 8, _hoisted_17)
          ], 8, _hoisted_16)
        ]),
        _createVNode(_component_the_locale_selector, { class: "locale-selector top-5 right-5 absolute" })
      ])
    ])
  ]))
}